import BuildingFormComponent, {
  BuildingFormViewProps,
  BuildingFormComponentProps,
} from './BuildingFormComponent';

export default BuildingFormComponent;

export type { BuildingFormComponentProps, BuildingFormViewProps };
